export default __webpack_public_path__ + "static/media/delete.7a24be14.svg";